var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"finial"},[_c('div',[_c('div',[_vm._t("img")],2),_vm._v(" "),_c('p',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }